import { render, staticRenderFns } from "./GradeCard.vue?vue&type=template&id=51918596&scoped=true&"
import script from "./GradeCard.ts?vue&type=script&lang=js&"
export * from "./GradeCard.ts?vue&type=script&lang=js&"
import style0 from "./GradeCard.css?vue&type=style&index=0&id=51918596&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51918596",
  null
  
)

export default component.exports